import { Dialog, DialogPanel } from '@headlessui/react';
import { useState } from 'react';

import { ErrorIcon } from '@/assets/icons';
import { handleSupportContact } from '@/common/utils';

interface ErrorIndicatorProps {
  fileName: string;
  containerStyle?: string;
  erroredOperations: Array<{
    id: string;
    operationType: string;
    operationStatus: string;
  }>;
}

export const ErrorIndicator = ({ fileName, containerStyle }: ErrorIndicatorProps) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsPopupOpen(true);
  };

  return (
    <>
      <div
        className={`${containerStyle} flex size-[16px] cursor-pointer items-center justify-center hover:opacity-80`}
        data-testid="error-indicator"
        aria-label={`${fileName} has processing errors`}
        onClick={handleClick}
      >
        <img src={ErrorIcon} alt="Processing error" className="size-[16px]" />
      </div>

      <Dialog
        open={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
        className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black/50"
      >
        <DialogPanel className="flex w-[500px] flex-col rounded-[16px] bg-[#242324] p-8">
          <div className="mb-4 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <img src={ErrorIcon} alt="error" />
              <h3 className="text-[24px] font-semibold text-marveri-white">Something Went Wrong</h3>
            </div>
            <button
              onClick={() => setIsPopupOpen(false)}
              className="text-marveri-white hover:opacity-80"
              aria-label="Close"
            >
              ✕
            </button>
          </div>

          <div className="mb-4">
            <p className="mb-3 text-sm text-marveri-white">
              We ran into an error processing your document set:
            </p>

            <div className="rounded-[4px] border border-container-hover bg-container-default p-3">
              <p className="text-sm text-marveri-white">
                <strong>Need Help?</strong> Please{' '}
                <button
                  onClick={handleSupportContact}
                  className="text-marveri-gold underline hover:opacity-80 focus:outline-none"
                >
                  contact our support team
                </button>{' '}
                directly for assistance with these processing errors.
              </p>
            </div>
          </div>

          <div className="flex justify-end">
            <button
              onClick={() => setIsPopupOpen(false)}
              className="cursor-pointer rounded-full bg-[#EAE6EA]  px-[18px] py-3 text-[14px] font-medium hover:bg-N200"
            >
              Close
            </button>
          </div>
        </DialogPanel>
      </Dialog>
    </>
  );
};
